
import { Component, Vue, Prop } from 'vue-property-decorator'

@Component({
    name: 'full-loading'
})
export default class extends Vue {
    @Prop({ default: true }) loading!: boolean
    @Prop({ default: '加载中' }) loadingText!: string
}
